import api from '../api'

export default {

  home: async () => {
    return api.get(`api/home`)
  },

  statistics: async (reportDays) => {
    return api.get(`api/home/statistics?report_days=${reportDays}`)
  },

}
